import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AssetLibrary from './AssetLibrary';
import {
  CARD_TYPES,
  CARD_SUBTYPES,
  MONTH_INFO,
  SCORING_RULES,
  MATCHING_RULES,
  SPECIAL_RULES,
  GAME_SETTINGS,
} from './GoStopSpec';
// CSS migrated to Tailwind utilities

// ===== 테스트 존 페이지 관리 =====
const TEST_PAGES = [
  { id: 'gostop-cards', name: '🎴 고스톱 카드', icon: '🎴' },
  { id: 'gostop-rules', name: '📜 고스톱 룰', icon: '📜' },
  { id: 'gostop-spec', name: '📋 스펙 문서', icon: '📋' },
  { id: 'assets', name: '📁 에셋 라이브러리', icon: '📁' },
];

// 화투 이미지 매핑
const HWATU_IMAGE_MAP = {
  '1-1': '1766365648113-246585907.png',
  '1-2': '1766365648040-398829771.png',
  '1-3': '1766365647990-957864677.png',
  '1-4': '1766365647901-991381946.png',
  '2-1': '1766365648299-896721373.png',
  '2-2': '1766365648264-567946987.png',
  '2-3': '1766365648281-422771943.png',
  '2-4': '1766365648146-136778318.png',
  '3-1': '1766365648007-26931206.png',
  '3-2': '1766365648061-457781584.png',
  '3-3': '1766365648096-895991008.png',
  '3-4': '1766365647920-205705528.png',
  '4-1': '1766365648213-442459374.png',
  '4-2': '1766365648129-211245955.png',
  '4-3': '1766365648162-58848333.png',
  '4-4': '1766365648246-955995828.png',
  '5-1': '1766365647802-768277004.png',
  '5-2': '1766365647936-615083179.png',
  '5-3': '1766365647975-673220710.png',
  '5-4': '1766365648079-717804224.png',
  '6-1': '1766365648179-819603995.png',
  '6-2': '1766365648229-284854545.png',
  '6-3': '1766365648195-217754773.png',
  '6-4': '1766365648315-903974657.png',
  '7-1': '1766365647954-486907208.png',
  '7-2': '1766365647885-332796171.png',
  '7-3': '1766365647859-981807374.png',
  '7-4': '1766365648024-379925920.png',
  '8-1': '1766365648470-903551197.png',
  '8-2': '1766365648518-775832240.png',
  '8-3': '1766365648485-208944818.png',
  '8-4': '1766365648437-74352903.png',
  '9-1': '1766365648656-182981457.png',
  '9-2': '1766365648622-253389898.png',
  '9-3': '1766365648605-469820217.png',
  '9-4': '1766365648553-51756069.png',
  '10-1': '1766365648367-911477294.png',
  '10-2': '1766365648422-610609444.png',
  '10-3': '1766365648386-728581906.png',
  '10-4': '1766365648502-932841805.png',
  '11-1': '1766365648588-806626211.png',
  '11-2': '1766365648570-323944655.png',
  '11-3': '1766365648536-891418201.png',
  '11-4': '1766365648639-790562712.png',
  '12-1': '1766365648403-709711113.png',
  '12-2': '1766365648334-202283624.png',
  '12-3': '1766365648349-721958801.png',
  '12-4': '1766365648454-752753178.png',
};

// 화투 48장 정의 (수정 가능)
const HWATU_DECK = [
  // 1월 (송학) - 소나무와 학
  { month: 1, imageIndex: 1, name: '송학', type: '광', subtype: null, desc: '학+태양', piCount: 0 },
  { month: 1, imageIndex: 2, name: '송학', type: '띠', subtype: '홍단', desc: '홍단', piCount: 0 },
  { month: 1, imageIndex: 3, name: '송학', type: '피', subtype: null, desc: '소나무', piCount: 1 },
  { month: 1, imageIndex: 4, name: '송학', type: '피', subtype: null, desc: '소나무', piCount: 1 },
  // 2월 (매조) - 매화와 꾀꼬리
  { month: 2, imageIndex: 1, name: '매조', type: '열끗', subtype: '고도리', desc: '꾀꼬리', piCount: 0 },
  { month: 2, imageIndex: 2, name: '매조', type: '띠', subtype: '홍단', desc: '홍단', piCount: 0 },
  { month: 2, imageIndex: 3, name: '매조', type: '피', subtype: null, desc: '매화', piCount: 1 },
  { month: 2, imageIndex: 4, name: '매조', type: '피', subtype: null, desc: '매화', piCount: 1 },
  // 3월 (벚꽃) - 벚꽃과 장막
  { month: 3, imageIndex: 1, name: '벚꽃', type: '광', subtype: null, desc: '장막', piCount: 0 },
  { month: 3, imageIndex: 2, name: '벚꽃', type: '띠', subtype: '홍단', desc: '홍단', piCount: 0 },
  { month: 3, imageIndex: 3, name: '벚꽃', type: '피', subtype: null, desc: '벚꽃', piCount: 1 },
  { month: 3, imageIndex: 4, name: '벚꽃', type: '피', subtype: null, desc: '벚꽃', piCount: 1 },
  // 4월 (흑싸리) - 등나무와 두견새
  { month: 4, imageIndex: 1, name: '흑싸리', type: '열끗', subtype: '고도리', desc: '두견새', piCount: 0 },
  { month: 4, imageIndex: 2, name: '흑싸리', type: '띠', subtype: '초단', desc: '초단', piCount: 0 },
  { month: 4, imageIndex: 3, name: '흑싸리', type: '피', subtype: null, desc: '등나무', piCount: 1 },
  { month: 4, imageIndex: 4, name: '흑싸리', type: '피', subtype: null, desc: '등나무', piCount: 1 },
  // 5월 (난초) - 창포와 팔교
  { month: 5, imageIndex: 1, name: '난초', type: '열끗', subtype: null, desc: '팔교', piCount: 0 },
  { month: 5, imageIndex: 2, name: '난초', type: '띠', subtype: '초단', desc: '초단', piCount: 0 },
  { month: 5, imageIndex: 3, name: '난초', type: '피', subtype: null, desc: '창포', piCount: 1 },
  { month: 5, imageIndex: 4, name: '난초', type: '피', subtype: null, desc: '창포', piCount: 1 },
  // 6월 (모란) - 모란과 나비
  { month: 6, imageIndex: 1, name: '모란', type: '열끗', subtype: null, desc: '나비', piCount: 0 },
  { month: 6, imageIndex: 2, name: '모란', type: '띠', subtype: '청단', desc: '청단', piCount: 0 },
  { month: 6, imageIndex: 3, name: '모란', type: '피', subtype: null, desc: '모란', piCount: 1 },
  { month: 6, imageIndex: 4, name: '모란', type: '피', subtype: null, desc: '모란', piCount: 1 },
  // 7월 (홍싸리) - 싸리와 멧돼지
  { month: 7, imageIndex: 1, name: '홍싸리', type: '열끗', subtype: null, desc: '멧돼지', piCount: 0 },
  { month: 7, imageIndex: 2, name: '홍싸리', type: '띠', subtype: '초단', desc: '초단', piCount: 0 },
  { month: 7, imageIndex: 3, name: '홍싸리', type: '피', subtype: null, desc: '싸리', piCount: 1 },
  { month: 7, imageIndex: 4, name: '홍싸리', type: '피', subtype: null, desc: '싸리', piCount: 1 },
  // 8월 (공산) - 억새와 보름달, 기러기
  { month: 8, imageIndex: 1, name: '공산', type: '광', subtype: null, desc: '보름달', piCount: 0 },
  { month: 8, imageIndex: 2, name: '공산', type: '열끗', subtype: '고도리', desc: '기러기', piCount: 0 },
  { month: 8, imageIndex: 3, name: '공산', type: '피', subtype: null, desc: '억새', piCount: 1 },
  { month: 8, imageIndex: 4, name: '공산', type: '피', subtype: null, desc: '억새', piCount: 1 },
  // 9월 (국화) - 국화와 술잔
  { month: 9, imageIndex: 1, name: '국화', type: '열끗', subtype: null, desc: '술잔', piCount: 0 },
  { month: 9, imageIndex: 2, name: '국화', type: '띠', subtype: '청단', desc: '청단', piCount: 0 },
  { month: 9, imageIndex: 3, name: '국화', type: '피', subtype: null, desc: '국화', piCount: 1 },
  { month: 9, imageIndex: 4, name: '국화', type: '피', subtype: null, desc: '국화', piCount: 1 },
  // 10월 (단풍) - 단풍과 사슴
  { month: 10, imageIndex: 1, name: '단풍', type: '열끗', subtype: null, desc: '사슴', piCount: 0 },
  { month: 10, imageIndex: 2, name: '단풍', type: '띠', subtype: '청단', desc: '청단', piCount: 0 },
  { month: 10, imageIndex: 3, name: '단풍', type: '피', subtype: null, desc: '단풍', piCount: 1 },
  { month: 10, imageIndex: 4, name: '단풍', type: '피', subtype: null, desc: '단풍', piCount: 1 },
  // 11월 (오동) - 오동과 봉황
  { month: 11, imageIndex: 1, name: '오동', type: '광', subtype: '비광', desc: '봉황', piCount: 0 },
  { month: 11, imageIndex: 2, name: '오동', type: '피', subtype: null, desc: '오동', piCount: 1 },
  { month: 11, imageIndex: 3, name: '오동', type: '피', subtype: null, desc: '오동', piCount: 1 },
  { month: 11, imageIndex: 4, name: '오동', type: '피', subtype: '쌍피', desc: '쌍피', piCount: 2 },
  // 12월 (비) - 버드나무와 비
  { month: 12, imageIndex: 1, name: '비', type: '광', subtype: '비광', desc: '비광', piCount: 0 },
  { month: 12, imageIndex: 2, name: '비', type: '열끗', subtype: null, desc: '제비', piCount: 0 },
  { month: 12, imageIndex: 3, name: '비', type: '띠', subtype: null, desc: '띠', piCount: 0 },
  { month: 12, imageIndex: 4, name: '비', type: '피', subtype: '쌍피', desc: '쌍피', piCount: 2 },
];

// 고스톱 카드 테스트 컴포넌트
const GoStopCardTest = () => {
  const [selectedCards, setSelectedCards] = useState([]);
  const [viewMode, setViewMode] = useState('byMonth'); // 'byMonth' | 'byType'
  const [editingCard, setEditingCard] = useState(null);
  const [cardDeck, setCardDeck] = useState(HWATU_DECK);
  const [imageMap, setImageMap] = useState(HWATU_IMAGE_MAP);
  const [dragOverCard, setDragOverCard] = useState(null);
  const [notes, setNotes] = useState(''); // 메모/텍스트 입력

  // 카드 선택/해제
  const toggleCardSelection = (card) => {
    setSelectedCards(prev => {
      const exists = prev.find(c => c.month === card.month && c.imageIndex === card.imageIndex);
      if (exists) {
        return prev.filter(c => !(c.month === card.month && c.imageIndex === card.imageIndex));
      }
      return [...prev, card];
    });
  };

  // 월별 그룹
  const cardsByMonth = cardDeck.reduce((acc, card) => {
    if (!acc[card.month]) acc[card.month] = [];
    acc[card.month].push(card);
    return acc;
  }, {});

  // 타입별 그룹
  const cardsByType = cardDeck.reduce((acc, card) => {
    if (!acc[card.type]) acc[card.type] = [];
    acc[card.type].push(card);
    return acc;
  }, {});

  // 선택된 카드 매칭 체크
  const getMatchInfo = () => {
    if (selectedCards.length < 2) return null;

    const months = [...new Set(selectedCards.map(c => c.month))];
    if (months.length === 1) {
      const month = months[0];
      const allCardsOfMonth = cardDeck.filter(c => c.month === month);
      return {
        isMatch: true,
        month,
        matchedCards: selectedCards,
        allMonthCards: allCardsOfMonth,
        totalPi: selectedCards.reduce((sum, c) => sum + c.piCount, 0)
      };
    }
    return { isMatch: false };
  };

  // 카드 수정
  const updateCard = (month, imageIndex, field, value) => {
    setCardDeck(prev => prev.map(card => {
      if (card.month === month && card.imageIndex === imageIndex) {
        return { ...card, [field]: value };
      }
      return card;
    }));
  };

  // 이미지 URL 가져오기 (동적 imageMap 사용)
  const getCardImageUrl = (month, index) => {
    const key = `${month}-${index}`;
    const filename = imageMap[key];
    return filename ? `https://api.ilouli.com/api/files/view/${filename}` : null;
  };

  // 드래그 앤 드롭 핸들러
  const handleDragOver = (e, card) => {
    e.preventDefault();
    setDragOverCard(`${card.month}-${card.imageIndex}`);
  };

  const handleDragLeave = () => {
    setDragOverCard(null);
  };

  const handleDrop = (e, card) => {
    e.preventDefault();
    setDragOverCard(null);

    // 파일 드롭
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      const file = files[0];
      if (file.type.startsWith('image/')) {
        // 파일 업로드 후 이미지 변경
        uploadAndChangeImage(card, file);
      }
      return;
    }

    // URL 드롭 (예: 파일 업로드 페이지에서 드래그)
    const url = e.dataTransfer.getData('text/plain');
    if (url && url.includes('/api/files/view/')) {
      const filename = url.split('/api/files/view/')[1];
      if (filename) {
        const key = `${card.month}-${card.imageIndex}`;
        setImageMap(prev => ({ ...prev, [key]: filename }));
      }
    }
  };

  // 이미지 업로드 및 변경
  const uploadAndChangeImage = async (card, file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('folder', '화투');

    try {
      const response = await fetch('https://api.ilouli.com/api/files/upload', {
        method: 'POST',
        body: formData,
      });

      if (response.ok) {
        const data = await response.json();
        const key = `${card.month}-${card.imageIndex}`;
        setImageMap(prev => ({ ...prev, [key]: data.file.filename }));
      }
    } catch (error) {
      console.error('이미지 업로드 실패:', error);
    }
  };

  // 카드 컴포넌트 (드래그 앤 드롭 지원)
  const CardDisplay = ({ card, isSelected, onClick, enableDrop = false }) => {
    const imageUrl = getCardImageUrl(card.month, card.imageIndex);
    const isDragOver = dragOverCard === `${card.month}-${card.imageIndex}`;

    const typeColors = {
      '광': 'bg-gradient-to-br from-yellow-400 to-amber-500 text-gray-900',
      '열끗': 'bg-gradient-to-br from-red-500 to-red-600 text-white',
      '띠': 'bg-gradient-to-br from-blue-500 to-blue-600 text-white',
      '피': 'bg-gray-400 text-gray-900',
    };

    return (
      <div
        className={`w-[70px] bg-gray-900 rounded-lg overflow-hidden border-2 border-red-700 cursor-pointer transition-all duration-200 hover:-translate-y-1 hover:shadow-xl ${isSelected ? 'border-blue-500 shadow-[0_0_0_3px_rgba(59,130,246,0.3)] -translate-y-1' : ''} ${isDragOver ? 'border-blue-500 shadow-[0_0_0_4px_rgba(59,130,246,0.3)] scale-105' : ''}`}
        onClick={onClick}
        onDragOver={enableDrop ? (e) => handleDragOver(e, card) : undefined}
        onDragLeave={enableDrop ? handleDragLeave : undefined}
        onDrop={enableDrop ? (e) => handleDrop(e, card) : undefined}
      >
        <div className="relative w-full h-[90px] bg-amber-50">
          {imageUrl ? (
            <img src={imageUrl} alt={`${card.month}월 ${card.name}`} draggable={false} className="w-full h-full object-cover" />
          ) : (
            <span className="flex items-center justify-center h-full text-gray-600">{card.month}월</span>
          )}
          {isDragOver && <div className="absolute inset-0 bg-blue-500/90 flex items-center justify-center text-white text-[0.7rem] font-semibold rounded-md">이미지 변경</div>}
        </div>
        <div className="flex flex-wrap gap-[2px] p-1 bg-gray-900">
          <span className="text-[0.6rem] text-white font-semibold">{card.month}월</span>
          <span className={`text-[0.5rem] px-1 py-[1px] rounded font-semibold ${typeColors[card.type] || 'bg-gray-500 text-white'}`}>{card.type}</span>
          {card.subtype && <span className="text-[0.5rem] text-yellow-400 font-medium">{card.subtype}</span>}
          {card.piCount > 1 && <span className="text-[0.5rem] text-red-500 font-bold">×{card.piCount}</span>}
        </div>
        <div className="text-[0.55rem] text-gray-400 px-1 py-[2px] pb-1 bg-gray-900 text-center">{card.desc}</div>
      </div>
    );
  };

  const matchInfo = getMatchInfo();

  return (
    <div className="flex flex-col gap-6">
      <div className="flex justify-between items-center flex-wrap gap-4">
        <h3 className="text-2xl font-semibold m-0">🎴 고스톱 카드 테스트</h3>
        <div className="flex bg-gray-100 rounded-[10px] p-1">
          <button
            className={`px-4 py-2 border-none rounded-lg cursor-pointer text-[0.85rem] font-medium transition-all duration-200 ${viewMode === 'byMonth' ? 'bg-white text-gray-900 shadow-md' : 'bg-transparent text-gray-500'}`}
            onClick={() => setViewMode('byMonth')}
          >
            월별 보기
          </button>
          <button
            className={`px-4 py-2 border-none rounded-lg cursor-pointer text-[0.85rem] font-medium transition-all duration-200 ${viewMode === 'byType' ? 'bg-white text-gray-900 shadow-md' : 'bg-transparent text-gray-500'}`}
            onClick={() => setViewMode('byType')}
          >
            타입별 보기
          </button>
        </div>
      </div>

      {/* 선택된 카드 & 매칭 정보 */}
      <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-5">
        <h4 className="text-base font-semibold m-0 mb-4 text-gray-900">선택된 카드 ({selectedCards.length}장)</h4>
        <div className="flex flex-wrap gap-3 min-h-[120px] items-center">
          {selectedCards.length === 0 ? (
            <p className="text-gray-500 text-[0.9rem]">카드를 클릭하여 선택하세요</p>
          ) : (
            selectedCards.map((card, idx) => (
              <CardDisplay
                key={`${card.month}-${card.imageIndex}-${idx}`}
                card={card}
                isSelected={true}
                onClick={() => toggleCardSelection(card)}
              />
            ))
          )}
        </div>
        {matchInfo && (
          <div className={`flex items-center gap-3 px-4 py-3 rounded-[10px] mt-4 font-medium ${matchInfo.isMatch ? 'bg-gradient-to-br from-green-500/10 to-green-600/10 border border-green-500/30 text-green-600' : 'bg-gradient-to-br from-red-500/10 to-red-600/10 border border-red-500/30 text-red-600'}`}>
            {matchInfo.isMatch ? (
              <>
                <span className="text-xl">✅</span>
                <span>매칭! {matchInfo.month}월 카드 {matchInfo.matchedCards.length}장</span>
                <span className="ml-auto bg-black/10 px-2 py-1 rounded-md text-[0.85rem]">총 피: {matchInfo.totalPi}장</span>
              </>
            ) : (
              <>
                <span className="text-xl">❌</span>
                <span>매칭 안됨 (다른 월 카드)</span>
              </>
            )}
          </div>
        )}
        <button className="mt-4 px-4 py-2 bg-red-600 text-white border-none rounded-lg cursor-pointer text-[0.85rem] font-medium transition-all duration-200 hover:bg-red-700" onClick={() => setSelectedCards([])}>선택 초기화</button>
      </div>

      {/* 카드 목록 */}
      {viewMode === 'byMonth' ? (
        <div className="flex flex-col gap-4">
          {Object.entries(cardsByMonth).map(([month, cards]) => (
            <div key={month} className="bg-white rounded-xl overflow-hidden shadow-sm">
              <div className="flex items-center gap-3 px-4 py-3 bg-gradient-to-br from-gray-50 to-gray-100 border-b border-gray-200">
                <span className="font-bold text-gray-900">{month}월</span>
                <span className="text-gray-500 text-[0.9rem]">{cards[0]?.name}</span>
              </div>
              <div className="flex flex-wrap gap-4 p-4">
                {cards.map(card => (
                  <div key={`${card.month}-${card.imageIndex}`} className="relative flex flex-col items-center gap-2">
                    <CardDisplay
                      card={card}
                      isSelected={selectedCards.some(c => c.month === card.month && c.imageIndex === card.imageIndex)}
                      onClick={() => toggleCardSelection(card)}
                      enableDrop={true}
                    />
                    <button
                      className="px-2 py-1 bg-gray-100 border border-gray-200 rounded-md cursor-pointer text-[0.8rem] transition-all duration-200 hover:bg-gray-200"
                      onClick={() => setEditingCard(editingCard === `${card.month}-${card.imageIndex}` ? null : `${card.month}-${card.imageIndex}`)}
                    >
                      ✏️
                    </button>
                    {editingCard === `${card.month}-${card.imageIndex}` && (
                      <div className="absolute top-full left-1/2 -translate-x-1/2 z-[100] bg-white rounded-xl p-4 shadow-xl min-w-[200px] flex flex-col gap-3 mt-2" onClick={(e) => e.stopPropagation()}>
                        <label className="flex flex-col gap-1 text-[0.8rem] font-medium text-gray-900">
                          타입:
                          <select
                            value={card.type}
                            onChange={(e) => updateCard(card.month, card.imageIndex, 'type', e.target.value)}
                            className="p-2 border border-gray-200 rounded-md text-[0.85rem]"
                          >
                            <option value="광">광</option>
                            <option value="열끗">열끗</option>
                            <option value="띠">띠</option>
                            <option value="피">피</option>
                          </select>
                        </label>
                        <label className="flex flex-col gap-1 text-[0.8rem] font-medium text-gray-900">
                          서브타입:
                          <select
                            value={card.subtype || ''}
                            onChange={(e) => updateCard(card.month, card.imageIndex, 'subtype', e.target.value || null)}
                            className="p-2 border border-gray-200 rounded-md text-[0.85rem]"
                          >
                            <option value="">없음</option>
                            <option value="홍단">홍단</option>
                            <option value="청단">청단</option>
                            <option value="초단">초단</option>
                            <option value="고도리">고도리</option>
                            <option value="비광">비광</option>
                            <option value="쌍피">쌍피</option>
                          </select>
                        </label>
                        <label className="flex flex-col gap-1 text-[0.8rem] font-medium text-gray-900">
                          피 개수:
                          <input
                            type="number"
                            min="0"
                            max="2"
                            value={card.piCount}
                            onChange={(e) => updateCard(card.month, card.imageIndex, 'piCount', parseInt(e.target.value))}
                            onClick={(e) => e.stopPropagation()}
                            onKeyDown={(e) => e.stopPropagation()}
                            className="p-2 border border-gray-200 rounded-md text-[0.85rem]"
                          />
                        </label>
                        <label className="flex flex-col gap-1 text-[0.8rem] font-medium text-gray-900">
                          설명:
                          <input
                            type="text"
                            value={card.desc}
                            onChange={(e) => updateCard(card.month, card.imageIndex, 'desc', e.target.value)}
                            onClick={(e) => e.stopPropagation()}
                            onKeyDown={(e) => e.stopPropagation()}
                            onFocus={(e) => e.stopPropagation()}
                            className="p-2 border border-gray-200 rounded-md text-[0.85rem]"
                          />
                        </label>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="flex flex-col gap-6">
          {['광', '열끗', '띠', '피'].map(type => {
            const headerColors = {
              '광': 'bg-gradient-to-br from-yellow-400 to-amber-500 text-gray-900',
              '열끗': 'bg-gradient-to-br from-red-500 to-red-600 text-white',
              '띠': 'bg-gradient-to-br from-blue-500 to-blue-600 text-white',
              '피': 'bg-gradient-to-br from-gray-400 to-gray-500 text-white',
            };
            return (
            <div key={type} className="bg-white rounded-xl overflow-hidden shadow-sm">
              <div className={`flex items-center justify-between px-4 py-3 ${headerColors[type]}`}>
                <span className="font-bold text-lg">{type}</span>
                <span className="text-[0.9rem] opacity-80">{cardsByType[type]?.length || 0}장</span>
              </div>
              <div className="flex flex-wrap gap-3 p-4">
                {(cardsByType[type] || []).map(card => (
                  <CardDisplay
                    key={`${card.month}-${card.imageIndex}`}
                    card={card}
                    isSelected={selectedCards.some(c => c.month === card.month && c.imageIndex === card.imageIndex)}
                    onClick={() => toggleCardSelection(card)}
                  />
                ))}
              </div>
            </div>
          )})}
        </div>
      )}

      {/* 점수 규칙 안내 */}
      <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-5">
        <h4 className="text-base font-semibold m-0 mb-4">점수 규칙</h4>
        <div className="grid grid-cols-[repeat(auto-fill,minmax(180px,1fr))] gap-3">
          {[
            { name: '오광', desc: '광 5장', score: '15점' },
            { name: '사광', desc: '광 4장 (비광 포함)', score: '4점' },
            { name: '삼광', desc: '광 3장 (비광 제외)', score: '3점' },
            { name: '비삼광', desc: '광 3장 (비광 포함)', score: '2점' },
            { name: '고도리', desc: '2,4,8월 새 3장', score: '5점' },
            { name: '홍단', desc: '1,2,3월 홍단 3장', score: '3점' },
            { name: '청단', desc: '6,9,10월 청단 3장', score: '3점' },
            { name: '초단', desc: '4,5,7월 초단 3장', score: '3점' },
            { name: '열끗', desc: '5장 이상', score: '장수-4점' },
            { name: '띠', desc: '5장 이상', score: '장수-4점' },
            { name: '피', desc: '10장 이상', score: '장수-9점' },
          ].map((rule) => (
            <div key={rule.name} className="flex items-center gap-2 bg-white px-3 py-2 rounded-lg text-[0.85rem]">
              <span className="font-semibold text-gray-900">{rule.name}</span>
              <span className="text-gray-500 flex-1 text-[0.75rem]">{rule.desc}</span>
              <span className="font-bold text-green-600 bg-green-500/10 px-[0.4rem] py-[0.2rem] rounded text-[0.8rem]">{rule.score}</span>
            </div>
          ))}
        </div>
      </div>

      {/* 메모/노트 */}
      <div className="bg-gradient-to-br from-yellow-100 to-yellow-200 rounded-2xl p-5">
        <h4 className="text-base font-semibold m-0 mb-4 text-yellow-800">📝 메모 및 노트</h4>
        <textarea
          className="w-full p-4 border-2 border-yellow-700/20 rounded-xl text-[0.9rem] font-inherit resize-y bg-white/80 text-gray-900 transition-colors duration-200 focus:outline-none focus:border-amber-500 focus:bg-white placeholder:text-gray-400"
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
          placeholder="카드 관련 메모, 수정 사항, 아이디어 등을 자유롭게 작성하세요..."
          rows={5}
        />
      </div>

      {/* JSON 출력 */}
      <div className="bg-gray-900 rounded-2xl p-5 text-white">
        <h4 className="text-base font-semibold m-0 mb-4">현재 설정 (복사하여 Games.js에 적용)</h4>
        <div className="flex flex-wrap gap-2 mb-4">
          <button className="px-4 py-2 bg-blue-500 text-white border-none rounded-lg cursor-pointer text-[0.85rem] font-medium transition-all duration-200 hover:bg-blue-600 hover:-translate-y-[1px]" onClick={() => {
            navigator.clipboard.writeText(JSON.stringify(cardDeck, null, 2));
            alert('덱 설정이 클립보드에 복사되었습니다!');
          }}>
            📋 덱 JSON 복사
          </button>
          <button className="px-4 py-2 bg-blue-500 text-white border-none rounded-lg cursor-pointer text-[0.85rem] font-medium transition-all duration-200 hover:bg-blue-600 hover:-translate-y-[1px]" onClick={() => {
            navigator.clipboard.writeText(`const HWATU_IMAGE_MAP = ${JSON.stringify(imageMap, null, 2)};`);
            alert('이미지 맵이 클립보드에 복사되었습니다!');
          }}>
            🖼️ 이미지맵 복사
          </button>
          <button className="px-4 py-2 bg-blue-500 text-white border-none rounded-lg cursor-pointer text-[0.85rem] font-medium transition-all duration-200 hover:bg-blue-600 hover:-translate-y-[1px]" onClick={() => {
            const fullConfig = {
              HWATU_IMAGE_MAP: imageMap,
              HWATU_DECK: cardDeck,
              notes: notes
            };
            navigator.clipboard.writeText(JSON.stringify(fullConfig, null, 2));
            alert('전체 설정이 클립보드에 복사되었습니다!');
          }}>
            📦 전체 설정 복사
          </button>
        </div>
        <div className="space-y-2">
          <details className="[&>summary]:px-4 [&>summary]:py-3 [&>summary]:bg-gray-700 [&>summary]:rounded-lg [&>summary]:cursor-pointer [&>summary]:text-[0.9rem] [&>summary]:font-medium [&>summary]:hover:bg-gray-600 [&[open]>summary]:rounded-b-none">
            <summary>덱 설정 JSON</summary>
            <pre className="bg-gray-800 p-4 rounded-b-lg overflow-x-auto text-[0.75rem] max-h-[300px] overflow-y-auto m-0">{JSON.stringify(cardDeck, null, 2)}</pre>
          </details>
          <details className="[&>summary]:px-4 [&>summary]:py-3 [&>summary]:bg-gray-700 [&>summary]:rounded-lg [&>summary]:cursor-pointer [&>summary]:text-[0.9rem] [&>summary]:font-medium [&>summary]:hover:bg-gray-600 [&[open]>summary]:rounded-b-none">
            <summary>이미지맵 JSON</summary>
            <pre className="bg-gray-800 p-4 rounded-b-lg overflow-x-auto text-[0.75rem] max-h-[300px] overflow-y-auto m-0">{`const HWATU_IMAGE_MAP = ${JSON.stringify(imageMap, null, 2)};`}</pre>
          </details>
        </div>
      </div>
    </div>
  );
};

// ===== 고스톱 스펙 문서 컴포넌트 =====
const GoStopSpecDoc = () => {
  const [activeTab, setActiveTab] = useState('overview');

  return (
    <div className="flex flex-col gap-6">
      <div className="text-center pb-4 border-b border-gray-200">
        <h2 className="text-2xl font-bold m-0 mb-2 text-gray-900">📋 고스톱 게임 스펙 문서</h2>
        <p className="text-gray-500 text-[0.9rem] m-0">GoStopSpec.js 파일에서 모든 규칙을 관리합니다</p>
      </div>

      <div className="flex flex-wrap gap-2 p-2 bg-gray-100 rounded-xl">
        {['overview', 'cards', 'scoring', 'matching', 'special'].map((tab) => {
          const labels = { overview: '개요', cards: '카드 타입', scoring: '점수 규칙', matching: '매칭 규칙', special: '특수 규칙' };
          return (
            <button
              key={tab}
              className={`px-4 py-2 border-none rounded-lg cursor-pointer text-[0.85rem] font-medium transition-all duration-200 ${activeTab === tab ? 'bg-white text-gray-900 shadow-md' : 'bg-transparent text-gray-500 hover:bg-white/50 hover:text-gray-900'}`}
              onClick={() => setActiveTab(tab)}
            >
              {labels[tab]}
            </button>
          );
        })}
      </div>

      <div className="bg-white rounded-2xl p-6 shadow-md">
        {activeTab === 'overview' && (
          <div>
            <h3 className="text-xl font-semibold m-0 mb-4 text-gray-900">🎮 게임 설정</h3>
            <div className="grid grid-cols-[repeat(auto-fill,minmax(220px,1fr))] gap-4 mb-6">
              <div className="bg-gray-50 rounded-xl p-4 border-l-4 border-blue-500">
                <h4 className="m-0 mb-2 text-[0.95rem] font-semibold">플레이어</h4>
                <ul className="m-0 pl-4 text-[0.85rem] text-gray-600">
                  <li>최소: {GAME_SETTINGS.players.min}명</li>
                  <li>최대: {GAME_SETTINGS.players.max}명</li>
                  <li>기본: {GAME_SETTINGS.players.default}명</li>
                </ul>
              </div>
              <div className="bg-gray-50 rounded-xl p-4 border-l-4 border-blue-500">
                <h4 className="m-0 mb-2 text-[0.95rem] font-semibold">카드 배분 (2인)</h4>
                <ul className="m-0 pl-4 text-[0.85rem] text-gray-600">
                  <li>총 카드: {GAME_SETTINGS.cards.total}장</li>
                  <li>1인당: {GAME_SETTINGS.cards.perPlayer[2]}장</li>
                  <li>바닥: {GAME_SETTINGS.cards.floor[2]}장</li>
                </ul>
              </div>
              <div className="bg-gray-50 rounded-xl p-4 border-l-4 border-blue-500">
                <h4 className="m-0 mb-2 text-[0.95rem] font-semibold">승리 조건</h4>
                <ul className="m-0 pl-4 text-[0.85rem] text-gray-600">
                  <li>최소 점수: {GAME_SETTINGS.winCondition.minScore}점</li>
                  <li>목표 점수: {GAME_SETTINGS.winCondition.defaultTarget}점</li>
                </ul>
              </div>
            </div>

            <h3 className="text-xl font-semibold m-0 mb-4 text-gray-900">📁 파일 구조</h3>
            <pre className="bg-gray-800 text-gray-200 p-4 rounded-lg text-[0.8rem] overflow-x-auto whitespace-pre font-mono">{`
// GoStopSpec.js 구조
export const CARD_TYPES = { ... };      // 카드 종류 (광, 열끗, 띠, 피)
export const CARD_SUBTYPES = { ... };   // 서브타입 (홍단, 청단, 고도리 등)
export const MONTH_INFO = { ... };      // 월별 정보
export const HWATU_DECK = [ ... ];      // 48장 카드 데이터
export const SCORING_RULES = [ ... ];   // 점수 규칙 (checkFn 포함)
export const MATCHING_RULES = { ... };  // 매칭 규칙
export const SPECIAL_RULES = [ ... ];   // 특수 규칙
export const GAME_SETTINGS = { ... };   // 게임 설정
            `.trim()}</pre>
          </div>
        )}

        {activeTab === 'cards' && (
          <div>
            <h3 className="text-xl font-semibold m-0 mb-4 text-gray-900">🃏 카드 타입 정의</h3>
            <div className="grid grid-cols-[repeat(auto-fill,minmax(220px,1fr))] gap-4 mb-6">
              {Object.values(CARD_TYPES).map(type => (
                <div key={type.id} className="bg-gray-50 rounded-xl p-4 border-l-4" style={{ borderLeftColor: type.color }}>
                  <h4 className="m-0 mb-2 text-[0.95rem] font-semibold">{type.name} ({type.nameEn})</h4>
                  <p className="m-0 mb-2 text-[0.85rem] text-gray-500">{type.description}</p>
                  <div className="text-[0.75rem] text-gray-400 mt-2 pt-2 border-t border-gray-200">총 {type.totalCount}장</div>
                </div>
              ))}
            </div>

            <h3 className="text-xl font-semibold m-0 mb-4 text-gray-900">🏷️ 서브타입 정의</h3>
            <div className="grid grid-cols-[repeat(auto-fill,minmax(220px,1fr))] gap-4 mb-6">
              {Object.values(CARD_SUBTYPES).map(sub => (
                <div key={sub.id} className="bg-gray-50 rounded-xl p-4 border-l-4" style={{ borderLeftColor: sub.color }}>
                  <h4 className="m-0 mb-2 text-[0.95rem] font-semibold">{sub.name} ({sub.nameEn})</h4>
                  <p className="m-0 mb-2 text-[0.85rem] text-gray-500">{sub.description}</p>
                  <div className="text-[0.75rem] text-gray-400 mt-2 pt-2 border-t border-gray-200">해당 월: {sub.months.join(', ')}월</div>
                </div>
              ))}
            </div>

            <h3 className="text-xl font-semibold m-0 mb-4 text-gray-900">📅 월별 정보</h3>
            <table className="w-full border-collapse text-[0.85rem] mb-4">
              <thead>
                <tr className="[&>th]:px-3 [&>th]:py-2 [&>th]:text-left [&>th]:border-b [&>th]:border-gray-200 [&>th]:bg-gray-100 [&>th]:font-semibold [&>th]:text-gray-600"><th>월</th><th>이름</th><th>꽃/식물</th><th>설명</th></tr>
              </thead>
              <tbody>
                {Object.entries(MONTH_INFO).map(([month, info]) => (
                  <tr key={month} className="[&>td]:px-3 [&>td]:py-2 [&>td]:text-left [&>td]:border-b [&>td]:border-gray-200">
                    <td>{month}월</td>
                    <td>{info.name}</td>
                    <td>{info.flower}</td>
                    <td>{info.description}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {activeTab === 'scoring' && (
          <div>
            <h3 className="text-xl font-semibold m-0 mb-4 text-gray-900">💰 점수 규칙 ({SCORING_RULES.length}개)</h3>
            <p className="text-[0.85rem] text-gray-500 mb-4 bg-blue-500/10 px-3 py-2 rounded-lg">각 규칙에는 <code className="bg-gray-100 px-1 py-[2px] rounded text-[0.8rem] font-mono text-red-500">checkFn</code> 함수가 있어 자동으로 점수를 계산합니다.</p>

            {['광', '열끗', '띠', '피'].map(category => {
              const rules = SCORING_RULES.filter(r => r.category === category);
              if (rules.length === 0) return null;
              return (
                <div key={category} className="mb-6">
                  <h4 className="text-base font-semibold m-0 mb-3 text-gray-800">{category} 조합</h4>
                  <table className="w-full border-collapse text-[0.85rem] mb-4">
                    <thead>
                      <tr className="[&>th]:px-3 [&>th]:py-2 [&>th]:text-left [&>th]:border-b [&>th]:border-gray-200 [&>th]:bg-gray-100 [&>th]:font-semibold [&>th]:text-gray-600"><th>ID</th><th>이름</th><th>조건</th><th>점수</th></tr>
                    </thead>
                    <tbody>
                      {rules.map(rule => (
                        <tr key={rule.id} className="[&>td]:px-3 [&>td]:py-2 [&>td]:text-left [&>td]:border-b [&>td]:border-gray-200">
                          <td><code className="bg-gray-100 px-1 py-[2px] rounded text-[0.8rem] font-mono text-red-500">{rule.id}</code></td>
                          <td>{rule.name}</td>
                          <td>{rule.condition}</td>
                          <td className="font-bold text-green-600">{rule.score ?? '동적'}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              );
            })}

            <h4 className="text-base font-semibold m-0 mb-3 text-gray-800">규칙 추가 방법</h4>
            <pre className="bg-gray-800 text-gray-200 p-4 rounded-lg text-[0.8rem] overflow-x-auto whitespace-pre font-mono">{`
// GoStopSpec.js의 SCORING_RULES 배열에 추가
{
  id: 'new-rule',           // 고유 ID
  name: '새 규칙',           // 표시 이름
  category: '광',           // 카테고리
  score: 10,               // 고정 점수 (또는 null)
  condition: '조건 설명',    // 조건 텍스트
  scoreFn: (cards) => ..., // 동적 점수 계산 (선택)
  checkFn: (cards) => ..., // 조건 체크 함수 (필수)
}
            `.trim()}</pre>
          </div>
        )}

        {activeTab === 'matching' && (
          <div>
            <h3 className="text-xl font-semibold m-0 mb-4 text-gray-900">🔗 매칭 규칙</h3>
            <div className="bg-gray-50 rounded-xl p-4 mb-6 border-l-4 border-blue-500">
              <h4 className="m-0 mb-2 text-[0.95rem] font-semibold">기본 규칙</h4>
              <p className="m-0 text-[0.85rem] text-gray-600"><strong>{MATCHING_RULES.basic.name}:</strong> {MATCHING_RULES.basic.description}</p>
            </div>

            <h4 className="text-base font-semibold m-0 mb-3 text-gray-800">매칭 시나리오</h4>
            <table className="w-full border-collapse text-[0.85rem] mb-6">
              <thead>
                <tr className="[&>th]:px-3 [&>th]:py-2 [&>th]:text-left [&>th]:border-b [&>th]:border-gray-200 [&>th]:bg-gray-100 [&>th]:font-semibold [&>th]:text-gray-600"><th>바닥 카드 수</th><th>액션</th><th>설명</th><th>보너스</th></tr>
              </thead>
              <tbody>
                {MATCHING_RULES.scenarios.map((scenario, idx) => (
                  <tr key={idx} className="[&>td]:px-3 [&>td]:py-2 [&>td]:text-left [&>td]:border-b [&>td]:border-gray-200">
                    <td>{scenario.floorCount}장</td>
                    <td><code className="bg-gray-100 px-1 py-[2px] rounded text-[0.8rem] font-mono text-red-500">{scenario.action}</code></td>
                    <td>{scenario.description}<br/><small className="text-gray-400">{scenario.detail}</small></td>
                    <td>{scenario.bonus ? `${scenario.bonus.name} (피 +${scenario.bonus.count})` : '-'}</td>
                  </tr>
                ))}
              </tbody>
            </table>

            <h4 className="text-base font-semibold m-0 mb-3 text-gray-800">매칭 로직</h4>
            <pre className="bg-gray-800 text-gray-200 p-4 rounded-lg text-[0.8rem] overflow-x-auto whitespace-pre font-mono">{`
// 카드 매칭 체크
import { canMatch, getMatchingScenario } from './GoStopSpec';

// 두 카드가 매칭 가능한지 확인
if (canMatch(myCard, floorCard)) {
  // 같은 월의 카드
}

// 바닥 상황에 따른 액션 결정
const scenario = getMatchingScenario(floorCardsOfSameMonth);
// scenario.action: 'place', 'take', 'select', 'takeAll'
            `.trim()}</pre>
          </div>
        )}

        {activeTab === 'special' && (
          <div>
            <h3 className="text-xl font-semibold m-0 mb-4 text-gray-900">⚡ 특수 규칙 ({SPECIAL_RULES.length}개)</h3>
            <div className="grid grid-cols-[repeat(auto-fill,minmax(280px,1fr))] gap-4">
              {SPECIAL_RULES.map(rule => (
                <div key={rule.id} className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-4 border border-gray-200">
                  <h4 className="m-0 mb-2 text-[0.95rem] font-semibold text-gray-900">{rule.name}</h4>
                  <p className="m-0 mb-3 text-[0.85rem] text-gray-600">{rule.description}</p>
                  {rule.effects && (
                    <ul className="m-0 pl-4 text-[0.8rem] text-gray-500 mb-3">
                      {rule.effects.map((e, i) => (
                        <li key={i}>{e.description}</li>
                      ))}
                    </ul>
                  )}
                  {rule.bonus && (
                    <div className="text-[0.75rem] text-blue-600 bg-blue-500/10 px-2 py-1 rounded inline-block mr-2">
                      보너스: {rule.bonus.type} +{rule.bonus.count || rule.bonus.multiplier + '배'}
                    </div>
                  )}
                  {rule.effect && <div className="text-[0.75rem] text-green-600 bg-green-500/10 px-2 py-1 rounded inline-block">효과: {rule.effect}</div>}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// ===== 고스톱 룰 문서 컴포넌트 =====
const GoStopRules = () => {
  const [activeSection, setActiveSection] = useState('basic');

  const sections = [
    { id: 'basic', name: '기본 규칙' },
    { id: 'cards', name: '패 구성' },
    { id: 'scoring', name: '점수 계산' },
    { id: 'special', name: '특수 규칙' },
    { id: 'tips', name: '전략 팁' },
  ];

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-wrap gap-2 p-2 bg-gray-100 rounded-xl">
        {sections.map(section => (
          <button
            key={section.id}
            className={`px-4 py-2 border-none rounded-lg cursor-pointer text-[0.85rem] font-medium transition-all duration-200 ${activeSection === section.id ? 'bg-white text-gray-900 shadow-md' : 'bg-transparent text-gray-500 hover:bg-white/50 hover:text-gray-900'}`}
            onClick={() => setActiveSection(section.id)}
          >
            {section.name}
          </button>
        ))}
      </div>

      <div className="bg-white rounded-2xl p-6 shadow-md">
        {activeSection === 'basic' && (
          <div className="flex flex-col gap-5">
            <h3 className="text-xl font-semibold m-0 text-gray-900">🎴 기본 규칙</h3>
            <div className="bg-gray-50 rounded-xl p-4 border-l-4 border-blue-500">
              <h4 className="m-0 mb-2 text-[0.95rem] font-semibold">게임 목표</h4>
              <p className="m-0 text-[0.85rem] text-gray-600">먼저 정해진 점수(보통 3점 또는 7점)에 도달하여 "고" 또는 "스톱"을 선언하는 것이 목표입니다.</p>
            </div>
            <div className="bg-gray-50 rounded-xl p-4 border-l-4 border-blue-500">
              <h4 className="m-0 mb-2 text-[0.95rem] font-semibold">게임 진행</h4>
              <ol className="m-0 pl-4 text-[0.85rem] text-gray-600 [&>li]:mb-1">
                <li><strong>패 돌리기:</strong> 2인 플레이 시 각자 10장씩, 바닥에 8장</li>
                <li><strong>선 결정:</strong> 먼저 치는 사람이 "선"</li>
                <li><strong>패 내기:</strong> 손에서 1장을 내고, 덱에서 1장을 뒤집음</li>
                <li><strong>패 먹기:</strong> 같은 월의 패끼리 매칭하여 획득</li>
                <li><strong>고/스톱:</strong> 점수가 나면 계속할지(고) 그만할지(스톱) 선택</li>
              </ol>
            </div>
            <div className="bg-gray-50 rounded-xl p-4 border-l-4 border-blue-500">
              <h4 className="m-0 mb-2 text-[0.95rem] font-semibold">매칭 규칙</h4>
              <ul className="m-0 pl-4 text-[0.85rem] text-gray-600 [&>li]:mb-1">
                <li>같은 월의 패 2장이 바닥에 있을 때: 선택하여 1장 가져감</li>
                <li>같은 월의 패 3장이 바닥에 있을 때: 3장 모두 가져감 ("싹쓸이")</li>
                <li>바닥에 매칭되는 패가 없으면: 내 패를 바닥에 내려놓음</li>
              </ul>
            </div>
          </div>
        )}

        {activeSection === 'cards' && (
          <div className="flex flex-col gap-5">
            <h3 className="text-xl font-semibold m-0 text-gray-900">🃏 패 구성 (총 48장)</h3>
            <div className="grid grid-cols-[repeat(auto-fill,minmax(260px,1fr))] gap-4">
              <div className="bg-gradient-to-br from-yellow-50 to-yellow-100 rounded-xl p-4 border-l-4 border-yellow-500">
                <h4 className="m-0 mb-2 text-[0.95rem] font-semibold">광 (5장)</h4>
                <p className="m-0 mb-2 text-[0.85rem] text-gray-600">1월(송학), 3월(벚꽃), 8월(공산), 11월(오동), 12월(비)</p>
                <ul className="m-0 pl-4 text-[0.85rem] text-gray-600 [&>li]:mb-1">
                  <li>가장 높은 가치의 패</li>
                  <li>광 조합으로 높은 점수 획득</li>
                  <li>11월, 12월은 "비광"으로 별도 취급</li>
                </ul>
              </div>
              <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-xl p-4 border-l-4 border-red-500">
                <h4 className="m-0 mb-2 text-[0.95rem] font-semibold">열끗/10끗 (9장)</h4>
                <p className="m-0 mb-2 text-[0.85rem] text-gray-600">각 월의 동물/사물 그림이 있는 패</p>
                <ul className="m-0 pl-4 text-[0.85rem] text-gray-600 [&>li]:mb-1">
                  <li>2, 4, 8월: 새 그림 (고도리)</li>
                  <li>5월: 팔교, 6월: 나비</li>
                  <li>7월: 멧돼지, 9월: 술잔</li>
                  <li>10월: 사슴, 12월: 제비</li>
                </ul>
              </div>
              <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-4 border-l-4 border-blue-500">
                <h4 className="m-0 mb-2 text-[0.95rem] font-semibold">띠 (10장)</h4>
                <ul className="m-0 pl-4 text-[0.85rem] text-gray-600 [&>li]:mb-1">
                  <li><span className="inline-block px-2 py-[2px] rounded text-[0.75rem] font-semibold bg-red-500 text-white">홍단</span> 1, 2, 3월 - 글씨 있는 빨간 띠</li>
                  <li><span className="inline-block px-2 py-[2px] rounded text-[0.75rem] font-semibold bg-blue-500 text-white">청단</span> 6, 9, 10월 - 파란 띠</li>
                  <li><span className="inline-block px-2 py-[2px] rounded text-[0.75rem] font-semibold bg-red-400 text-white">초단</span> 4, 5, 7월 - 글씨 없는 빨간 띠</li>
                  <li>12월 띠: 특수 (조합 불가)</li>
                </ul>
              </div>
              <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-4 border-l-4 border-gray-400">
                <h4 className="m-0 mb-2 text-[0.95rem] font-semibold">피 (24장)</h4>
                <ul className="m-0 pl-4 text-[0.85rem] text-gray-600 [&>li]:mb-1">
                  <li>일반 피: 각 월에 2장씩 (1점)</li>
                  <li><span className="inline-block px-2 py-[2px] rounded text-[0.75rem] font-semibold bg-purple-500 text-white">쌍피</span> 11월, 12월에 각 1장 (2점)</li>
                  <li>10장 이상 모으면 점수 획득</li>
                </ul>
              </div>
            </div>
          </div>
        )}

        {activeSection === 'scoring' && (
          <div className="flex flex-col gap-5">
            <h3 className="text-xl font-semibold m-0 text-gray-900">💰 점수 계산</h3>
            <div className="flex flex-col gap-4">
              <h4 className="m-0 text-[0.95rem] font-semibold">광 조합</h4>
              <table className="w-full border-collapse text-[0.85rem]">
                <thead>
                  <tr className="[&>th]:px-3 [&>th]:py-2 [&>th]:text-left [&>th]:border-b [&>th]:border-gray-200 [&>th]:bg-gray-100 [&>th]:font-semibold [&>th]:text-gray-600"><th>조합</th><th>조건</th><th>점수</th></tr>
                </thead>
                <tbody>
                  <tr className="[&>td]:px-3 [&>td]:py-2 [&>td]:border-b [&>td]:border-gray-200"><td>오광</td><td>광 5장 모두</td><td className="font-bold text-green-600">15점</td></tr>
                  <tr className="[&>td]:px-3 [&>td]:py-2 [&>td]:border-b [&>td]:border-gray-200"><td>사광</td><td>비광 제외 광 4장</td><td className="font-bold text-green-600">4점</td></tr>
                  <tr className="[&>td]:px-3 [&>td]:py-2 [&>td]:border-b [&>td]:border-gray-200"><td>비사광</td><td>비광 포함 광 4장</td><td className="font-bold text-green-600">4점</td></tr>
                  <tr className="[&>td]:px-3 [&>td]:py-2 [&>td]:border-b [&>td]:border-gray-200"><td>삼광</td><td>비광 제외 광 3장</td><td className="font-bold text-green-600">3점</td></tr>
                  <tr className="[&>td]:px-3 [&>td]:py-2 [&>td]:border-b [&>td]:border-gray-200"><td>비삼광</td><td>비광 포함 광 3장</td><td className="font-bold text-green-600">2점</td></tr>
                </tbody>
              </table>

              <h4 className="m-0 text-[0.95rem] font-semibold mt-4">열끗/띠 조합</h4>
              <table className="w-full border-collapse text-[0.85rem]">
                <thead>
                  <tr className="[&>th]:px-3 [&>th]:py-2 [&>th]:text-left [&>th]:border-b [&>th]:border-gray-200 [&>th]:bg-gray-100 [&>th]:font-semibold [&>th]:text-gray-600"><th>조합</th><th>조건</th><th>점수</th></tr>
                </thead>
                <tbody>
                  <tr className="[&>td]:px-3 [&>td]:py-2 [&>td]:border-b [&>td]:border-gray-200"><td>고도리</td><td>2, 4, 8월 새 3장</td><td className="font-bold text-green-600">5점</td></tr>
                  <tr className="[&>td]:px-3 [&>td]:py-2 [&>td]:border-b [&>td]:border-gray-200"><td>홍단</td><td>1, 2, 3월 홍단 3장</td><td className="font-bold text-green-600">3점</td></tr>
                  <tr className="[&>td]:px-3 [&>td]:py-2 [&>td]:border-b [&>td]:border-gray-200"><td>청단</td><td>6, 9, 10월 청단 3장</td><td className="font-bold text-green-600">3점</td></tr>
                  <tr className="[&>td]:px-3 [&>td]:py-2 [&>td]:border-b [&>td]:border-gray-200"><td>초단</td><td>4, 5, 7월 초단 3장</td><td className="font-bold text-green-600">3점</td></tr>
                  <tr className="[&>td]:px-3 [&>td]:py-2 [&>td]:border-b [&>td]:border-gray-200"><td>열끗</td><td>5장 이상</td><td className="font-bold text-green-600">(장수-4)점</td></tr>
                  <tr className="[&>td]:px-3 [&>td]:py-2 [&>td]:border-b [&>td]:border-gray-200"><td>띠</td><td>5장 이상</td><td className="font-bold text-green-600">(장수-4)점</td></tr>
                </tbody>
              </table>

              <h4 className="m-0 text-[0.95rem] font-semibold mt-4">피 점수</h4>
              <table className="w-full border-collapse text-[0.85rem]">
                <thead>
                  <tr className="[&>th]:px-3 [&>th]:py-2 [&>th]:text-left [&>th]:border-b [&>th]:border-gray-200 [&>th]:bg-gray-100 [&>th]:font-semibold [&>th]:text-gray-600"><th>조합</th><th>조건</th><th>점수</th></tr>
                </thead>
                <tbody>
                  <tr className="[&>td]:px-3 [&>td]:py-2 [&>td]:border-b [&>td]:border-gray-200"><td>피</td><td>10장 이상</td><td className="font-bold text-green-600">(장수-9)점</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        )}

        {activeSection === 'special' && (
          <div className="flex flex-col gap-5">
            <h3 className="text-xl font-semibold m-0 text-gray-900">⚡ 특수 규칙</h3>
            <div className="bg-gray-50 rounded-xl p-4 border-l-4 border-purple-500">
              <h4 className="m-0 mb-2 text-[0.95rem] font-semibold">고 (Go)</h4>
              <p className="m-0 mb-2 text-[0.85rem] text-gray-600">점수가 나면 "고"를 외쳐 게임을 계속할 수 있습니다.</p>
              <ul className="m-0 pl-4 text-[0.85rem] text-gray-600 [&>li]:mb-1">
                <li>1번 고: 다음 점수 2배</li>
                <li>2번 고: 다음 점수 4배</li>
                <li>3번 고 이상: 계속 2배씩 증가</li>
              </ul>
            </div>
            <div className="bg-gray-50 rounded-xl p-4 border-l-4 border-orange-500">
              <h4 className="m-0 mb-2 text-[0.95rem] font-semibold">뻑 (Ppuk)</h4>
              <p className="m-0 mb-2 text-[0.85rem] text-gray-600">같은 월 패가 바닥에 있을 때 낸 패도 같은 월이면 "뻑"</p>
              <ul className="m-0 pl-4 text-[0.85rem] text-gray-600 [&>li]:mb-1">
                <li>3뻑: 상대방에게 벌칙</li>
              </ul>
            </div>
            <div className="bg-gray-50 rounded-xl p-4 border-l-4 border-green-500">
              <h4 className="m-0 mb-2 text-[0.95rem] font-semibold">쪽 / 싹쓸이</h4>
              <ul className="m-0 pl-4 text-[0.85rem] text-gray-600 [&>li]:mb-1">
                <li><strong>쪽:</strong> 바닥의 패 2장과 내 패 1장이 매칭 → 피 1장 보너스</li>
                <li><strong>싹쓸이:</strong> 내 패로 바닥 패 모두 가져감 → 피 1장 보너스</li>
              </ul>
            </div>
            <div className="bg-gray-50 rounded-xl p-4 border-l-4 border-red-500">
              <h4 className="m-0 mb-2 text-[0.95rem] font-semibold">폭탄</h4>
              <p className="m-0 text-[0.85rem] text-gray-600">같은 월 패 4장이 한 손에 있으면 → 무조건 승리 또는 보너스</p>
            </div>
            <div className="bg-gray-50 rounded-xl p-4 border-l-4 border-cyan-500">
              <h4 className="m-0 mb-2 text-[0.95rem] font-semibold">흔들기 / 나가리</h4>
              <ul className="m-0 pl-4 text-[0.85rem] text-gray-600 [&>li]:mb-1">
                <li><strong>흔들기:</strong> 같은 월 3장을 가지고 시작 시 선택적 공개 → 점수 2배</li>
                <li><strong>나가리:</strong> 덱이 다 떨어질 때까지 아무도 점수 못 냄 → 무승부</li>
              </ul>
            </div>
          </div>
        )}

        {activeSection === 'tips' && (
          <div className="flex flex-col gap-5">
            <h3 className="text-xl font-semibold m-0 text-gray-900">💡 전략 팁</h3>
            <div className="bg-gray-50 rounded-xl p-4 border-l-4 border-yellow-500">
              <h4 className="m-0 mb-2 text-[0.95rem] font-semibold">기본 전략</h4>
              <ul className="m-0 pl-4 text-[0.85rem] text-gray-600 [&>li]:mb-1">
                <li>광을 우선적으로 모으세요 - 가장 높은 점수</li>
                <li>고도리(2,4,8월 새)는 5점으로 가치가 높습니다</li>
                <li>피를 많이 모으면 안정적인 점수 획득 가능</li>
                <li>상대방이 모으는 패를 파악하고 방해하세요</li>
              </ul>
            </div>
            <div className="bg-gray-50 rounded-xl p-4 border-l-4 border-indigo-500">
              <h4 className="m-0 mb-2 text-[0.95rem] font-semibold">고 타이밍</h4>
              <ul className="m-0 pl-4 text-[0.85rem] text-gray-600 [&>li]:mb-1">
                <li>이미 높은 점수가 확보됐을 때 고</li>
                <li>상대방 패가 거의 없을 때 안전하게 고</li>
                <li>덱에 남은 패가 적을 때는 리스크 고려</li>
              </ul>
            </div>
            <div className="bg-gray-50 rounded-xl p-4 border-l-4 border-pink-500">
              <h4 className="m-0 mb-2 text-[0.95rem] font-semibold">주의사항</h4>
              <ul className="m-0 pl-4 text-[0.85rem] text-gray-600 [&>li]:mb-1">
                <li>비광(11월, 12월 광)만으로는 삼광 안 됨</li>
                <li>12월 띠는 단 조합에 포함 안 됨</li>
                <li>쌍피는 피 2장으로 계산</li>
              </ul>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const TestZone = () => {
  const { t } = useTranslation();
  const [activePage, setActivePage] = useState('gostop-cards');

  return (
    <div className="max-w-[1200px] mx-auto py-12 px-6 font-[-apple-system,BlinkMacSystemFont,'SF_Pro_Display',sans-serif]">
      <header className="text-center mb-12">
        <h1 className="text-5xl font-bold tracking-tight text-gray-900 mb-3">{t('testZone.title')}</h1>
        <p className="text-xl text-gray-500 font-normal">{t('testZone.subtitle')}</p>
      </header>

      {/* 페이지 탭 네비게이션 */}
      <nav className="flex gap-2 p-2 bg-gray-100 rounded-2xl mb-6 overflow-x-auto">
        {TEST_PAGES.map(page => (
          <button
            key={page.id}
            className={`flex items-center gap-2 px-5 py-3 bg-transparent border-none rounded-xl cursor-pointer text-[0.9rem] font-medium transition-all duration-200 whitespace-nowrap ${activePage === page.id ? 'bg-white text-gray-900 shadow-md' : 'text-gray-500 hover:bg-white/50 hover:text-gray-900'}`}
            onClick={() => setActivePage(page.id)}
          >
            <span className="text-lg">{page.icon}</span>
            <span className="max-md:hidden">{page.name}</span>
          </button>
        ))}
      </nav>

      <div className="flex flex-col gap-8">
        {/* 고스톱 카드 테스트 */}
        {activePage === 'gostop-cards' && (
          <section className="bg-white rounded-3xl p-8 shadow-lg">
            <GoStopCardTest />
          </section>
        )}

        {/* 고스톱 룰 문서 */}
        {activePage === 'gostop-rules' && (
          <section className="bg-white rounded-3xl p-8 shadow-lg">
            <GoStopRules />
          </section>
        )}

        {/* 고스톱 스펙 문서 */}
        {activePage === 'gostop-spec' && (
          <section className="bg-white rounded-3xl p-8 shadow-lg">
            <GoStopSpecDoc />
          </section>
        )}

        {/* 에셋 라이브러리 */}
        {activePage === 'assets' && (
          <section className="bg-white rounded-3xl p-8 shadow-lg">
            <h2 className="text-2xl font-semibold text-gray-900 m-0 mb-6 pb-4 border-b border-gray-100">📁 Asset Library</h2>
            <AssetLibrary />
          </section>
        )}
      </div>
    </div>
  );
};

export default TestZone;
